<template>
<div>
  	<!-- page wrapper start -->
	<div class="pg-wrapper fav-product-list">

    <app-header>
      <div class="title-bar" slot="header-foot">
				<button @click="goBack()" class="button is-flex nav-back">
					<img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back">
				</button>
			  <h1 class="title has-text-black">Favourites</h1>
			</div>
    </app-header>

    <main class="content-wrapper is-relative has-background-white-bis pb0">
      <div class="container full">
			<div class="columns mv0 flex-grow-1">

				<!-- TABS -->
				<fav-tabs v-if="loaded" tab="product" :productCount="vg_locationFavouriteProducts.length" :storeCount="vg_favouriteLocations.length"></fav-tabs>

				<!-- Search Results Content -->
        <div class="column flex-grow-1 section-search-results" v-if="!loaded">
          <loading></loading>
        </div>

				<div class="column flex-grow-1 section-search-results" v-else>
					<section class="columns is-centered">
						<div class="column search-result-column">
							<div class="wrap-is-constant-240px">

							<!--  Product Tile: Gather -->
              <template v-for="(item, itemIndex) in vg_locationFavouriteProducts">

                <div class="is-constant-240px" 
                  v-bind:key="itemIndex + '-fav_item'" 
                 >
          
                  <weed-card 
                    v-if="item.product_family == 'cannabis'" 
                    :callback="goToLocationProductDetail" 
                    :item="item" 
                  ></weed-card>

                  <accessory-card 
                    v-else
                    :callback="goToLocationProductDetail" 
                    :item="item" 
                  ></accessory-card>

                </div>

                <!-- <item v-bind:key="itemIndex + '-item'" :callback="goToLocationProductDetail" :item="item"></item> -->
              </template>
             
             <!-- No product available -->
              <div class="column product-tile-wrapper is-6-desktop is-10-widescreen" v-if="loaded && vg_locationFavouriteProducts.length < 1">
                <h3>No Favourites Added.</h3>
							</div>

							</div>
						 </div>
					</section>
				</div>
			</div>
			</div>
		</main>
    <app-footer></app-footer>

	</div>
</div>
</template>
<script>
import Env from '@/env';
import FavTabs from '@/Components/Pages/User/Inc/FavTabs';
import Item from '@/Components/Pages/User/UserFavouriteProduct/ItemV2';
import { mapGetters, mapActions } from "vuex";
import UserApis from '@/Components/Controllers/UserApis';
import Helpers from "@/Components/Helpers/Helpers";

export default {
  components: {
    FavTabs,
    Item,
  },
  name: 'UserFavouriteProducts',
  data() {
    return {
      loaded: false,
    };
  },

  computed: {
    ...mapGetters({
      vg_favouriteLocations: "favouritestores/list",
      // vg_favouriteProducts: "favouriteproducts/list", // this will return all fav products
      vg_locationFavouriteProducts: "favouriteproducts/locationFavlist", // only return location fav product + escape discontinued
    }),
  },

  async mounted() {
    const self = this;
    let userFavProducts = await UserApis.fetchFavProducts();  
    let userFavLocIds = await UserApis.fetchFavLocations();
    Promise.all([userFavProducts, userFavLocIds]).then(() => {
      self.loaded = true;
    }); 
  },

  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage' });
    },
    // hasSaleTag(variants) {
    //   return Helpers.hasSaleTag(variants);
    // },
    goToLocationProductDetail(item) {
      this.$router.push({ name: 'LocationProductDetail', 
        params: { 
          business_slug: this.$route.params.business_slug,
          store_slug: this.$route.params.store_slug, 
          product_id: item.id 
        } 
      })
    },
  },
};
</script>

<style scoped>
.sm-img{
  max-height: 16px;
}
</style>
